const React = require('react');
const PropTypes = require('prop-types');
const { connect } = require('react-redux');
const { queryBenefits123Data } = require('actions/contactCenter/seeBenefits123');
const AccountBenefitsView = require('components/accounts/accountBenefitsView/accountBenefitsView');

class AccountBenefitsViewContainer extends React.Component {

    render() {
        const { immAccounts } = this.props;

        return (<AccountBenefitsView
            {...this.props}
            immAccounts={immAccounts}
        />);
    }
}

AccountBenefitsViewContainer.propTypes = {
    immAccountBenefitsData: PropTypes.object,
    queryBenefits123Data: PropTypes.func,
    immAccounts: PropTypes.object.isRequired,
    match: PropTypes.object.isRequired,
};

const mapStateToProps = state => ({
    immAccountBenefitsData: state.benefits123,
    immAccounts: state.accounts,
});

module.exports.constructor = AccountBenefitsViewContainer;
module.exports.AccountBenefitsViewContainer = connect(
    mapStateToProps,
    {
        queryBenefits123Data,
    }
)(AccountBenefitsViewContainer);
